import React from 'react';
import './Pricing.css';

const Pricing = () => {
  const plans = [
    {
      name: 'СТАРТ',
      price: '990',
      period: 'месяц',
      description: 'Для тех, кто только начинает свой путь',
      features: [
        'Доступ к базовой библиотеке тренировок',
        'Программы для новичков',
        'Трекинг базовых показателей',
        'Доступ к сообществу',
        'Мобильное приложение',
        'Система достижений'
      ],
      unavailable: [
        'AI-коуч AIRNI',
        'Персональные планы питания',
        'Продвинутые программы',
        'Приоритетная поддержка'
      ],
      popular: false
    },
    {
      name: 'ПРОГРЕСС',
      price: '1990',
      period: 'месяц',
      description: 'Оптимальный выбор для серьезных результатов',
      features: [
        'Полная библиотека 500+ тренировок',
        'Все уровни сложности',
        'AI-коуч AIRNI 24/7',
        'Персональные планы питания',
        'Продвинутая аналитика прогресса',
        'Доступ к эксклюзивным челленджам',
        'Приоритетная поддержка',
        'Без рекламы'
      ],
      unavailable: [],
      popular: true,
      badge: 'ЛУЧШИЙ ВЫБОР'
    },
    {
      name: 'ЧЕМПИОН',
      price: '14990',
      period: 'год',
      description: 'Максимальная экономия и все возможности',
      features: [
        'Все из тарифа ПРОГРЕСС',
        'Экономия 6000₽ в год',
        'Эксклюзивные программы от топ-тренеров',
        'Ранний доступ к новым функциям',
        'Персональные консультации',
        'Специальный значок в сообществе',
        'Подарки и мерч FitHousse'
      ],
      unavailable: [],
      popular: false,
      badge: 'ВЫГОДА 33%',
      savings: true
    }
  ];

  return (
    <section id="pricing" className="pricing section">
      <div className="container">
        <h2 className="section-title">Выбери Свой Путь</h2>
        <p className="pricing-intro">
          Без скрытых платежей. Без обязательств. Отмени подписку в любой момент.<br/>
          <strong>Гарантия возврата денег в течение 14 дней.</strong>
        </p>
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? 'popular' : ''} ${plan.savings ? 'savings' : ''}`}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {plan.badge && <div className="pricing-badge">{plan.badge}</div>}
              <div className="pricing-header">
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-description">{plan.description}</p>
                <div className="plan-price">
                  <span className="price-currency">₽</span>
                  <span className="price-value">{plan.price}</span>
                  <span className="price-period">/ {plan.period}</span>
                </div>
                {plan.savings && (
                  <div className="savings-info">
                    ≈ 1249₽/мес при годовой оплате
                  </div>
                )}
              </div>
              <div className="pricing-features">
                <ul className="features-list">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="feature-item available">
                      <span className="feature-icon">✓</span>
                      <span className="feature-text">{feature}</span>
                    </li>
                  ))}
                  {plan.unavailable.map((feature, idx) => (
                    <li key={idx} className="feature-item unavailable">
                      <span className="feature-icon">✕</span>
                      <span className="feature-text">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="pricing-cta">
                <button className={plan.popular ? 'btn-primary' : 'btn-secondary'}>
                  {plan.popular ? 'Начать Сейчас' : 'Выбрать План'}
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="pricing-guarantee">
          <div className="guarantee-icon">🛡️</div>
          <div className="guarantee-text">
            <h4>Гарантия результата или возврат денег</h4>
            <p>
              Мы настолько уверены в эффективности FitHousse, что даем 14 дней на то,
              чтобы попробовать сервис без риска. Не понравилось — вернем деньги, без вопросов.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
